import { render, staticRenderFns } from "./ListTeihoAddress.vue?vue&type=template&id=3c45d5ac&scoped=true&"
import script from "./ListTeihoAddress.vue?vue&type=script&lang=js&"
export * from "./ListTeihoAddress.vue?vue&type=script&lang=js&"
import style0 from "@/styles/table-styles.css?vue&type=style&index=0&id=3c45d5ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c45d5ac",
  null
  
)

export default component.exports